var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#00a14b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7997 11.5417H19.1913C19.7247 11.5417 20.158 11.9751 20.158 12.5084V13.5751C20.158 13.9667 19.9163 14.4501 19.6747 14.6917L17.5913 16.5334C17.2997 16.7751 17.108 17.2584 17.108 17.6501V19.7334C17.108 20.0251 16.9163 20.4084 16.6747 20.5584L15.9997 20.9834C15.3663 21.3751 14.4997 20.9334 14.4997 20.1584V17.5917C14.4997 17.2501 14.308 16.8167 14.108 16.5751L12.2663 14.6334C12.0247 14.4001 11.833 13.9584 11.833 13.6667V12.5584C11.833 11.9751 12.2663 11.5417 12.7997 11.5417Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5003 24.3334H18.5003C22.667 24.3334 24.3337 22.6667 24.3337 18.5001V13.5001C24.3337 9.33341 22.667 7.66675 18.5003 7.66675H13.5003C9.33366 7.66675 7.66699 9.33341 7.66699 13.5001V18.5001C7.66699 22.6667 9.33366 24.3334 13.5003 24.3334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFilter);
export default __webpack_public_path__ + "static/media/mobile-filter.54b64e83b2635dd90bd1817672c44051.svg";
export { ForwardRef as ReactComponent };